import { newTracker, trackPageView } from '@snowplow/browser-tracker';
import { trackStructEvent } from "@rtl_nl/rtl-snowplow";
import { MediaTrackingPlugin, enableMediaTracking } from '@snowplow/browser-plugin-media-tracking'
import { globalVars } from './variables';
import { isInViewport, hasHeight } from "./helperFunctions";

/**
 * 
 */
function initContentPageTracking(pageType) {

    // send event whenever section is in viewport
    document.addEventListener("scroll", () => {
        Array.from(document.querySelectorAll('.et_pb_section')).forEach((section) => {

            if (isInViewport(section) && hasHeight(section)) {
                let headerText;

                if (section.classList.contains('hero')) {
                    headerText = 'hero-section';
                } else {
                    const header = section.querySelector('h1, h2, h3, h4, h5, h6');
                    headerText = header ? header.innerText : "No section header";
                }

                trackStructEvent({
                    appId: globalVars.app_id,
                    category: pageType,
                    action: "show-section",
                    rtlElementContext: {
                        elementInteraction: "show",
                        elementName: headerText,
                        elementGroup: headerText,
                        elementType: "section",
                    },
                });
            }
        });
    });

    /**
     * General click listener.
     * For performance, we don't want to add a clack listener on each element,
     * but rather look at the event target of the click
     */

    document.addEventListener("click", (e) => {

        /**
         * click on the titel covers (whole page)
         */
        Array.from(document.querySelectorAll(".cover-anchor")).forEach((titleCover) => {
            if (e.target == titleCover) {
                // get elementGroup
                const section = titleCover.closest(".et_pb_section");
                let sectionHeader = section.querySelector('h1, h2, h3, h4, h5, h6').innerText || "No section header";

                // get title name
                const titleName = titleCover.querySelector("span").innerText || "Title not given";

                // get position of cover
                const article = titleCover.closest(".carousel-item");
                const titleWrapper = article.parentElement;
                const titleWrapperChildren = titleWrapper.childNodes;
                let articleIndex = '0';

                for (let i = 0; i < titleWrapperChildren.length; i++) {
                    if (titleWrapperChildren[i] == article) {
                        articleIndex = (i + 1).toString();
                        break;
                    }
                }

                // send click event to Snowplow
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: pageType,
                    action: "click-cover",
                    label: sectionHeader,
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: sectionHeader,
                        elementType: "cover",
                        elementName: titleName,
                        elementLabel: titleName,
                        elementStyle: 'cover',
                        elementPosition: articleIndex,
                    },
                });
                return;
            }
        });

        /**
         * a click on any of the create account buttons
         */
        Array.from(document.querySelectorAll('.page-wrapper .btn[href*="/abonnementen"]')).forEach((btn) => {
            if (e.target == btn) {

                const elementGroupVal = btn.innerText == 'Kies een pakket' ? 'choose-a-package' : 'watch-more-on-videoland' ;
                const elementLabelVal = btn.innerText == 'Kies een pakket' ? 'Kies een pakket' : 'Probeer het 14 dagen' ;
                trackStructEvent({
                    appId: globalVars.app_id,
                    category: pageType,
                    action: "start-trial",
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: elementGroupVal,
                        elementType: "button",
                        elementName: "cta-trial",
                        elementLabel: elementLabelVal,
                        elementStyle: "icon"
                    },
                });
            }
        });

        /**
         * a click on any of the toggle content buttons
         */
         Array.from(document.querySelectorAll('.page-wrapper .btn.toggle-content')).forEach((btn) => {
            if (e.target == btn || btn.contains(e.target)) {

                const section = btn.closest(".et_pb_section");
                const sectionHeader = section.querySelector('h1, h2, h3, h4, h5, h6').innerText || "No section header";

                trackStructEvent({
                    appId: globalVars.app_id,
                    category: pageType,
                    action: "click-toggle-content",
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: sectionHeader,
                        elementType: "button",
                        elementName: "toggle-content",
                        elementLabel: "toggle-content"
                    },
                });
            }
        });

        /**
         * clicking the carousel navigation buttons
         */
        Array.from(document.querySelectorAll('.slide-navigation .nav-arrow')).forEach((btn) => {
            if (e.target == btn) {
                let direction = 'left';
                if (btn.classList.contains('arrow-next')) direction = 'right';
                if (btn.classList.contains('disabled')) direction += '-disabled';

                const section = btn.closest(".et_pb_section");
                const sectionHeader = section.querySelector('h1, h2, h3, h4, h5, h6').innerText || "No section header";

                trackStructEvent({
                    appId: globalVars.app_id,
                    category: pageType,
                    action: "click-carousel",
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: sectionHeader,
                        elementType: "arrow-button",
                        elementName: "carousel",
                        elementLabel: direction
                    },
                });
            }
        });

        /**
         * expanding and collapsing timeline item
         */
        Array.from(document.querySelectorAll('.timeline-item .toggle-content')).forEach((btn) => {
            if (e.target == btn) {

                const section = btn.closest(".timeline-item");
                const title = section.querySelector('.title').innerText || "No title";

                const action = section.classList.contains('active') ? 'expand' : 'collapse';

                trackStructEvent({
                    appId: globalVars.app_id,
                    category: pageType,
                    action: "click-timeline",
                    label: title,
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: "timeline",
                        elementType: "button",
                        elementName: title,
                        elementLabel: action
                    },
                });
            }
        });

        /**
         * selecting a section to display using the content toggle
         */
        Array.from(document.querySelectorAll('.display-toggle .toggle')).forEach((btn) => {
            if (e.target == btn || btn.contains(e.target)) {

                const title = btn.querySelector('span').innerText || 'No title';

                trackStructEvent({
                    appId: globalVars.app_id,
                    category: pageType,
                    action: "click-content-toggle",
                    label: title,
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: "content toggle",
                        elementType: "button",
                        elementName: title,
                        elementLabel: 'show section'
                    },
                });
            }
        });

        /**
             * Selecting a tier in the tiering table, or clicking the 'kies {tier}' button INSIDE the card
             */
        Array.from(document.querySelectorAll(".tier__card")).forEach((tier) => {
            if (e.target == tier || tier.contains(e.target)) {
                let tierValue = tier.querySelector("a.btn").innerText;
                let tierName = "";

                if (e.target !== tier.querySelector("a.btn") || e.target == tier) {
                    tierValue = tierValue.split("kies ")[1];
                    tierName = "tier-title";
                } else if (e.target == tier.querySelector("a.btn")) {
                    tierValue = tierValue.split("Ik ")[1];
                    tierName = tierValue.split("kies ")[1] + "-bottom";
                }

                trackStructEvent({
                    appId: globalVars.app_id,
                    category: pageType,
                    action: "tier",
                    rtlElementContext: {
                        elementInteraction: "click",
                        elementGroup: "section-tier",
                        elementType: "button",
                        elementName: tierName,
                        elementLabel: tierValue,
                    },
                });
                return;
            }
        });
    });

    newTracker('sp2', globalVars.snowplow_collector_url, {
        appId: globalVars.app_id,
        plugins: [MediaTrackingPlugin()],
    });

    Array.from(document.querySelectorAll(".video .vjs-tech")).forEach((video) => {
        const videoId = video.getAttribute('id');
        enableMediaTracking({
            id: videoId,
            options: {
                volumeChangeTrackingInterval: 200,
                captureEvents: ['play', 'pause', 'seeked', 'progress', 'volumechange'],
            }
        });
    });
}

export { initContentPageTracking }